import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Widget } from '../../widgets.model';
import { CampaignPreviewData } from 'app/campaign/campaign-overview/campaign-preview/campaign-preview-models';
import { OnsiteCampaign, OnsiteCampaignType } from '../../campaign.model';
import { DateService } from 'app/shared/services/date-service';
import { OnsiteCampaignPausedReason } from '../../campaign.model';
import { CurrentContextService } from 'app/core/current-context.service';
import { Subscription } from 'rxjs';
import { CookieService } from 'app/core/cookie.service';

@Component({
  selector: 'app-campaign-creation-success-dialog',
  templateUrl: './campaign-creation-success-dialog.component.html',
  styleUrls: ['./campaign-creation-success-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CampaignCreationSuccessDialogComponent implements OnInit, OnDestroy {
  public campaignPreviewData: CampaignPreviewData;
  public widgets: Array<Widget>;
  public campaign: OnsiteCampaign;
  public isAbTest = false;
  public isSurveysPaused: boolean;
  public isCouponSetPaused: boolean;
  public accountHasVisits: boolean;
  public daysUntilReset: number;

  private currentContextSubscription: Subscription;
  private subscriptionArray: Subscription[] = [];

  constructor(
    public dialogRef: MatDialogRef<CampaignCreationSuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      widgets: Array<Widget>;
      campaignPreviewData: CampaignPreviewData;
      campaign: OnsiteCampaign;
    },
    private router: Router,
    private readonly currentContextService: CurrentContextService,
    private readonly dateService: DateService,
    private readonly cookieService: CookieService,
  ) {
    this.widgets = data.widgets;
    this.campaign = data.campaign;
    this.isAbTest = this.campaign && this.campaign.type === OnsiteCampaignType.ABTesting;
    this.isSurveysPaused = this.campaign.pausedReason === OnsiteCampaignPausedReason.SurveyResponsesOverLimit;
    this.isCouponSetPaused = this.campaign.pausedReason === OnsiteCampaignPausedReason.CouponsUsageAtPauseLimit;
    this.campaignPreviewData = data.campaignPreviewData;
  }

  public ngOnInit() {
    window.dispatchEvent(new Event('SuccessfullyPublishedCampaign'));
    this.currentContextSubscription = this.currentContextService.currentContextBS.subscribe((currentContext) => {
      if (currentContext) {
        this.accountHasVisits = currentContext.accountHasVisits;
        this.daysUntilReset = this.dateService.calculateDaysUntilReset(currentContext.limitations.resetDayInMonth);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptionArray.push(this.currentContextSubscription);
    this.subscriptionArray.forEach((subs) => subs && subs.unsubscribe());
  }

  public closeDialog() {
    this.cookieService.set('hidePublishSuccessDialog', true, 7, true);
    this.dialogRef.close({});
  }

  public toCampaignsPage() {
    this.router.navigate(['/campaigns']);
    this.dialogRef.close({});
  }
}
